import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './ActiveList.css';
import { ServicegetWhatsappComm, fetchTemplates } from "../Services/Service";
import Table from './DataTable/DataTable';
import { CustomLoader } from "../Services/CommonLibrary";
import { downloadExcelFromHTML } from './Utils';

function CommunicationWhatsapp() {

    const nav = useNavigate();

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * 50;

    const [serviceData, setServiceData] = useState([]);
    const [templateList, setTemplateList] = useState([]);

    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    const [showExportButton, setShowExportButton] = useState(true);

    useEffect(() => {
        loadTemplates();
    }, []);

    /* ---------------- LOAD TEMPLATE DROPDOWN ---------------- */
    const loadTemplates = async () => {
        setLoading(true);
        try {
            const res = await fetchTemplates();
            if (res?.data?.data) {
                const formatted = res.data.data.map(t => ({
                    value: t.id,
                    label: t.templateName
                }));

                setTemplateList([
                    { value: "", label: "All Templates" },
                    ...formatted
                ]);

                fetchWhatsappData("", "");
            }
        } catch (err) {
            console.error("Template load error:", err);
        }
        setLoading(false);
    };

    /* ---------------- FETCH DATA (TEMPLATE + STATUS) ---------------- */
    const fetchWhatsappData = async (templateId, status) => {
        setLoading(true);
        try {
            const res = await ServicegetWhatsappComm(templateId, status);
            setServiceData(res?.data?.data || []);
        } catch (err) {
            console.error("Whatsapp fetch error:", err);
            setServiceData([]);
        }
        setLoading(false);
    };

    /* ---------------- TEMPLATE CHANGE ---------------- */
    const onTemplateChange = (e) => {
        const value = e.target.value;
        setSelectedTemplate(value);
        fetchWhatsappData(value, selectedStatus);
    };

    /* ---------------- STATUS CHANGE ---------------- */
    const onStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        fetchWhatsappData(selectedTemplate, value);
    };

    /* ---------------- TABLE COLUMNS ---------------- */
    const columns = [
        {
            name: "#",
            cell: (row, index) => startIndex + index + 1,
            center: true,
            grow: 0
        },
        {
            name: "Mobile",
            selector: row => row.mobile,
            sortable: true,
            center: true
        },
        {
            name: "Whatsapp Text",
            cell: row => (
                <div className="text-wrap">{row.whatsappText}</div>
            ),
            grow: 3,
            center: true
        },
        {
            name: "Status",
            selector: row => row.status,
            sortable: true,
            center: true,
            conditionalCellStyles: [
                { when: row => row.status === 'Delivered', style: { color: 'green' } },
                { when: row => row.status === 'Sent', style: { color: 'blue' } },
                { when: row => row.status === 'Read', style: { color: 'purple' } },
                { when: row => row.status === 'Failed', style: { color: 'red' } }
            ]
        },
        {
            name: "Sent Date",
            selector: row => row.createdTime,
            sortable: true,
            center: true
        }
    ];

    /* ---------------- PAGINATION ---------------- */
    const onChangePage = (page) => {
        setCurrentPage(page);
    };

    // ---------------- EXPORT DATA ----------------
    const [loadingExport, setLoadingExport] = useState(false);
    const fetchExportData = async () => {
        setLoadingExport(true);
        const exportExcel = "excel";
        try {
            const res = await ServicegetWhatsappComm(selectedTemplate, selectedStatus, exportExcel);
            const excelData = res?.data || [];

            downloadExcelFromHTML(excelData, "Whatsapp_Communication_Data");
        } catch (err) {
            console.error("Export error:", err);
        }
        setLoadingExport(false);
    };

    return (
        <section>
            {/* FILTERS */}
            <div className="row mt-3">
                <div className="col-md-3">
                    <select
                        className="form-control form-control-sm"
                        value={selectedTemplate}
                        onChange={onTemplateChange}
                    >
                        {templateList.map((item, i) => (
                            <option key={i} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control form-control-sm"
                        value={selectedStatus}
                        onChange={onStatusChange}
                    >
                        <option value="">All Status</option>
                        <option value="Sent">Sent</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Read">Read</option>
                        <option value="Failed">Failed</option>
                    </select>
                </div>
                
                {showExportButton && (
                    <div className="col-md-3 ms-auto text-end">
                        <button
                            className="btn btn-success me-2 btn-sm"
                            onClick={fetchExportData}
                            disabled={loadingExport}
                        >
                            {loadingExport ? 'Exporting Data...' : 'Export Data'}
                        </button>
                    </div>
                )}
            </div>

            {/* TABLE */}
            <div className="row">
                <div className="table-responsive">
                    <Table
                        data={serviceData}
                        column={columns}
                        onChangePage={onChangePage}
                    />
                </div>
            </div>

            {loading && <CustomLoader />}

        </section>
    );
}

export default CommunicationWhatsapp;
